export default {
    subtitle: 'Select the document type to convert to',
    title: 'Convert',
};
